export const listYesNo = [{ key: 'true', value: "Sim" }, { key: 'false', value: "Não" }];

export const emailType = [
  { type: 'cobranca_boleto_novo', description: 'Cobrança - Novo boleto' },
  { type: 'cobranca_boleto_reenvio', description: 'Cobrança - Reenvio de boleto' },
  { type: 'cobranca_aviso_suspensao', description: 'Cobrança - Aviso de Suspensão' },
  { type: 'cobranca_aviso_suspenso', description: 'Cobrança - Suspenso' },
  { type: 'cobranca_aviso_remocao', description: 'Cobrança - Aviso de Remoção' },
];

export const taskState = [
  { id: 0, description: 'Na fila', type: 0, color: '#ccc' },
  { id: 1, description: 'Em Produção', type: 1, color: '#2f54eb' },
  { id: 2, description: 'Bloqueado', type: 3, color: '#f5222d' },
  { id: 3, description: 'Revisão', type: 4, color: '#facf14' },
  { id: 4, description: 'Concluído', type: 2, color: '#52c41a' },
];

export const taskType = [
  { id: 1, description: 'Tarefa', color: '#fadb14' },
  { id: 2, description: 'Bug', color: '#ff0014' },
];

export const taskPriority = [
  { id: 1, description: 'Crítica', color: '#f5222d' },
  { id: 2, description: 'Alta', color: '#fa8c16' },
  { id: 3, description: 'Normal', color: '#1677ff' },
  { id: 4, description: 'Baixa', color: '#8c8c8c' },
];

export const taskTab = [
  { id: 1, key: 'main', description: 'Detalhes' },
  { id: 2, key: 'comment', description: 'Comentários' },
  { id: 3, key: 'planning', description: 'Planejamento' },
  { id: 4, key: 'hour', description: 'Horas trabalhadas' },
  { id: 5, key: 'history', description: 'Histórico' },
];
